export default "__VITE_ASSET__Ci0MpbS2__"